import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'platform-button',
    standalone: true,
    imports: [ButtonModule, SplitButtonModule, TooltipModule],
    template: `
        <!-- Standard Button -->
        @if (buttonType === 'button') {
            <p-button
                [label]="label"
                [icon]="iconToDisplay"
                [iconPos]="iconPosition"
                [text]="text"
                [outlined]="outlined"
                [severity]="severity"
                [disabled]="disabled"
                (onClick)="buttonClick.emit($event)"
                [styleClass]="styleClass"
                [style]="style"
                [pTooltip]="pTooltip"
                [tooltipPosition]="tooltipPosition"
            >
                @if (useCustomIcon && icon) {
                    <ng-template pTemplate="icon">
                        <span
                            style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%"
                        >
                            <img [src]="icon" alt="icon" />
                        </span>
                    </ng-template>
                }
            </p-button>
        }

        <!-- Split Button -->
        @if (buttonType === 'splitButton') {
            <p-splitButton
                [label]="label"
                [icon]="icon"
                [text]="text"
                [model]="menuItems"
                [outlined]="outlined"
                [severity]="severity"
                [disabled]="disabled"
                [styleClass]="styleClass"
                (onClick)="buttonClick.emit($event)"
                (onDropdownClick)="menuItemClick.emit($event)"
            ></p-splitButton>
        }
    `,
    styles: [
        `
            :host {
                display: inline-block;
            }
        `,
    ],
})
export class ConfigurableButtonComponent implements OnInit {
    @Input() buttonType: 'button' | 'splitButton' = 'button';
    @Input() label = '';
    @Input() icon = '';
    @Input() iconPosition: 'left' | 'right' = 'left';
    @Input() text = false;
    @Input() outlined = false;
    @Input() severity: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'help' | 'danger' = 'primary';
    @Input() disabled = false;
    @Input() menuItems: MenuItem[] = [];
    @Input() appliedStyle: StyleObject = {
        labelColor: '',
        bgColor: '',
    };
    @Input() styleClass: string | undefined;
    @Input() pTooltip: string | undefined;
    @Input() tooltipPosition: 'left' | 'right' | 'top' | 'bottom' = 'bottom';
    @Input() useCustomIcon: boolean = false;

    @Output() buttonClick = new EventEmitter<any>();
    @Output() menuItemClick = new EventEmitter<any>();

    public iconToDisplay: string | undefined;
    public style: Record<string, any> = {};

    ngOnInit(): void {
        this.style = { color: this.appliedStyle.labelColor, background: this.appliedStyle.bgColor };
        this.iconToDisplay = !this.useCustomIcon ? this.icon : undefined;
    }
}

interface StyleObject {
    labelColor: string;
    bgColor: string;
}
